import { render, staticRenderFns } from "./collectionType3.vue?vue&type=template&id=7c5fb3ba"
import script from "./collectionType3.vue?vue&type=script&lang=js"
export * from "./collectionType3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c5fb3ba')) {
      api.createRecord('7c5fb3ba', component.options)
    } else {
      api.reload('7c5fb3ba', component.options)
    }
    module.hot.accept("./collectionType3.vue?vue&type=template&id=7c5fb3ba", function () {
      api.rerender('7c5fb3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialcenter/reconciliation/collectionType3.vue"
export default component.exports